export default (value) => {

    return value.replace('L', 'AAAAAAA');
}
